"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var annotationTransformer_1 = require("../../../common/helpers/annotationTransformer");
var AdminCreateDocumentController = /** @class */ (function () {
    function AdminCreateDocumentController($state, $scope, FlashService, $window, DocumentTemplateModel) {
        this.$state = $state;
        this.$scope = $scope;
        this.FlashService = FlashService;
        this.$window = $window;
        this.DocumentTemplateModel = DocumentTemplateModel;
        this.busy = false;
        // Initialize template data
        this.templateData = {
            name: "",
            description: "",
            status: "draft",
        };
        // Initialize component props for PDF editor
        this.editorProps = {
            mode: "create",
            templateName: this.templateData.name,
            templateDescription: this.templateData.description,
            templateStatus: this.templateData.status,
            pdfUrl: null,
        };
        // Initialize event handlers separately
        this.editorHandlers = {
            onSaveTemplate: this.handleTemplateSave.bind(this),
            onCancel: this.handleCancel.bind(this),
            onError: this.handleError.bind(this),
            onMetadataChange: this.handleMetadataChange.bind(this),
        };
    }
    AdminCreateDocumentController.prototype.handleTemplateSave = function (data) {
        var _this = this;
        if (this.busy) {
            return;
        }
        this.busy = true;
        // Validate template data
        var validation = this.DocumentTemplateModel.validateTemplate(data);
        if (!validation.valid) {
            this.FlashService.setMessage({
                type: "error",
                message: "Please fix the following errors: " + validation.errors.join(", "),
            });
            this.busy = false;
            return;
        }
        // Transform annotations to backend format
        var backendAnnotations = (0, annotationTransformer_1.transformAnnotationsForBackend)(data.annotations || []);
        // Prepare template data
        var templateData = {
            name: data.name || this.templateData.name || "Untitled Template",
            description: this.templateData.description || "",
            status: this.templateData.status || "draft",
            annotations: backendAnnotations,
            // signature_requirements removed - signatures are now part of annotations
            pdf_file: data.pdfFile,
        };
        this.DocumentTemplateModel.createTemplate(templateData)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: "Document template created successfully!",
            });
            _this.$state.go("drivecoach.admin.documenttemplates", {}, { reload: true });
        })
            .catch(function (error) {
            console.error("Error creating template:", error);
            _this.FlashService.setMessage({
                type: "error",
                message: "Failed to create document template. Please try again.",
            });
        })
            .finally(function () {
            _this.busy = false;
        });
    };
    AdminCreateDocumentController.prototype.handleCancel = function () {
        this.$state.go("drivecoach.admin.documenttemplates");
    };
    AdminCreateDocumentController.prototype.handleError = function (error) {
        console.error("PDF Editor Error:", error);
        this.FlashService.setMessage({
            type: "error",
            message: "An error occurred with the PDF editor. Please try again.",
        });
    };
    AdminCreateDocumentController.prototype.handleMetadataChange = function (data) {
        // Update local template data when metadata changes in Vue component
        if (data.field === "name") {
            this.templateData.name = data.value;
        }
        else if (data.field === "description") {
            this.templateData.description = data.value;
        }
        else if (data.field === "status") {
            this.templateData.status = data.value;
        }
    };
    return AdminCreateDocumentController;
}());
AdminCreateDocumentController.$inject = [
    "$state",
    "$scope",
    "FlashService",
    "$window",
    "DocumentTemplateModel",
];
exports.default = AdminCreateDocumentController;
